import requestFileSystemDirectory from './request_file_system_directory';

export default function (token, grantedBytes) {
  return requestFileSystemDirectory(token, null, grantedBytes);
}
